module.exports = __webpack_public_path__ + "static/img/result_main_banner.866e1b2e.png";